<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startDate" type="date" size="small" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endDate" type="date" size="small" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">订单号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderNo" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="display-row">
            <div class="query-title">用户姓名:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.customerName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">支付方式:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.paymentType" placeholder="请选择" multiple
                         collapse-tags size="small" clearable>
                <el-option key="0" value="0" label="余额支付"></el-option>
                <el-option key="1" value="1" label="银行卡支付"></el-option>
                <el-option key="2" value="2" label="Paypal支付"></el-option>
                <el-option key="3" value="3" label="银行卡+余额支付"></el-option>
                <el-option key="4" value="4" label="Paypal+余额支付"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align:right;padding-right:10px;floate:right;position: absolute;right: 0;">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item"> 付款总额：<template v-if="form.totalPaymentPrice != null">{{ form.totalPaymentPrice | formatMoney }}元</template><template v-else>—</template>
             <el-tooltip effect="light" content="中国运费和检品费是客户下单时的金额" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
                  border
                  height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="userName" align="center" label="用户ID">
            <template v-slot="scope">
              <div>
                <span>{{ scope.row.userName }}</span>
              </div>
              <div style="margin-top: 10px; padding-top: 10px;">
                <span>{{ scope.row.customerName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="下单时间" width="150" >
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="orderIds" align="center" label="订单号" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="ellipsis-clamp">
                {{ scope.row.orderIds }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="totalGoodsPrice" align="center" label="商品总额（元）">
            <template v-slot="scope">
              {{ scope.row.totalGoodsPrice | formatMoney }}
            </template>
          </el-table-column>
          <el-table-column prop="yggnyf" align="center" label="预估国内运费（元）">
            <template v-slot="scope">
              {{ scope.row.yggnyf | formatMoney }}
            </template>
          </el-table-column>
          <el-table-column prop="dgsxf" align="center" label="预估代购手续费（元）">
            <template v-slot="scope">
              {{ scope.row.dgsxf | formatMoney }}
            </template>
          </el-table-column>
          <el-table-column prop="zjpf" align="center" label="总检品费（元）" width="80">
          </el-table-column>
          <el-table-column prop="currencyRate" align="center" label="当日汇率" width="80">
            <template v-slot="scope">
              {{ formatSettlementRate(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="paymentType" align="center" label="付款方式">
            <template v-slot="scope">
              {{ scope.row.paymentType | payMethodFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="totalPaymentPrice" align="center" label="付款总额（元）">
            <template v-slot="scope">
              {{ scope.row.totalPaymentPrice | formatMoney }}<br>
              <span v-if="scope.row.totalBalancePayment > 0" style="color: rgb(255, 191, 0)">
                ({{ scope.row.totalPaymentTypePrice | formatMoney }} + {{ scope.row.totalBalancePayment | formatMoney }})
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="currencyAmount" align="center" label="付款总额 + 币种">
            <template v-slot="scope">
              <span style="color: #ffa621;">{{ formatSettlementAmount(scope.row) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="queryInfo.pageNum"
                       :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: {tableCon},
  name: 'orderBill',
  data() {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1,
        userName: "",
        customerName: "",
        paymentType: [],
        orderNo: ""
      },
      recordList: [],
      total: 0,
      form: { totalPaymentPrice: null },
    }
  },
  methods: {

    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction() {
      const params = {
        ...this.queryInfo,
        paymentType: this.queryInfo.paymentType.join(','),
      }
      this.$http({
        url: '/financial/exportOrderBill',
        method: 'get',
        // params: this.queryInfo,
        params,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '订单账单统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList() {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList() {
      const params = {
        ...this.queryInfo,
        paymentType: this.queryInfo.paymentType.join(','),
      }
      const {data: res} = await this.$http.get('/financial/queryOrderBill', {params});
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear() {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      this.queryInfo.orderNo = ''
      this.queryInfo.userName = ''
      this.queryInfo.endDate = ''
      this.queryInfo.startDate = ''
      this.queryInfo.paymentType = []
    },
    async getTool() {
      const params = {
        ...this.queryInfo,
        paymentType: this.queryInfo.paymentType.join(','),
      }
      const {data: res} = await this.$http.get('/financial/queryOrderBillHeader', {params});
      this.form = res.data || { totalPaymentPrice: null }
    }
  },
  activated() {
    this.getrecordList();
  },
  created() {
    this.getrecordList();
    this.getTool();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.tips {
  margin: 15px 0;
  text-align: right;
}

.tip-item {
  margin-left: 30px;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.ellipsis-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
